import styled from 'styled-components/macro';

export const StyledFormPageLayout = styled.main`
  width: 100%;
  min-height: 100vh;
  padding: 13rem 4rem 6rem;
`;
